<template>
  <div class="xSelectTree">
    <!-- 向上弹窗 -->
    <div v-if="from=='pro-cls-zy'" @click="disabled = true">
      <div class="mask" v-if="disabled" @click="disabled = false"></div>
      <el-popover
        placement="top-start"
        width="400"
        v-model="disabled"
        trigger="click">
        <div style="height:380px;overflow-y: auto;">
        <el-tree class="c-0 x-m-r-20 x-m-l-20 x-m-t-10 x-m-b-10" ref="tree1" :data="treeData" :props="treeProps" :current-node-key='chooseClsId'
          node-key="cls_id" default-expand-all :expand-on-click-node="false" highlight-current>
          <div class="x-flex x-row-between x-w100p x-p-r-5 x-p-l-5" slot-scope="{ node, data }" @click="fBlur(data)">
            <span>{{ node.label }}</span>
          </div>
        </el-tree>
        </div>
        <!-- <el-button slot="reference">click 激活</el-button> -->
        <el-input slot="reference" :placeholder="placeholder" v-model="input4" readonly="readonly">
          <i slot="suffix" class="el-input__icon el-icon-arrow-up" :class='isShowPop?"":"rotate"'></i>
        </el-input>
      </el-popover>
    </div>
    <!-- 向下弹窗 -->
    <div v-else>
      <div @click="fFocus">
        <el-input :placeholder="placeholder" v-model="input4" readonly="readonly">
          <i slot="suffix" class="el-input__icon el-icon-arrow-up" :class='isShowPop?"":"rotate"'></i>
        </el-input>
      </div>
      <!-- 遮罩层 用来取消弹窗的显示状态-->
      <div class="mask" v-if="isShowPop" @click="isShowPop = false"></div>
      <div class="pop" :class="[isShowPop?'h-380':'h-0',]" :style="from == 'import' && isShowPop?'height:180px':''" v-if="from!='pro-cls-zy'">
        <el-tree class="c-0 x-m-r-20 x-m-l-20 x-m-t-10 x-m-b-10" ref="tree1" :data="treeData" :props="treeProps"
          :current-node-key='chooseClsId' node-key="cls_id" default-expand-all :expand-on-click-node="false"
          highlight-current>
          <div class="x-flex x-row-between x-w100p x-p-r-5 x-p-l-5" slot-scope="{ node, data }" @click="fBlur(data)">
            <span>{{ node.label }}</span>
          </div>
        </el-tree>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      placeholder: {
        type: [String],
        default: '请选择',
      },
      treeData: [Array, Object],
      default: () => {
        return []
      },
      chooseClsName: {
        type: [String,Boolean],
        default: '',
      },
      from: {
        type: [String,Boolean],
        default: '',
      },
      chooseClsId: {
        type: [String,Boolean],
        default: '',
      },
    },
    data() {
      return {
        disabled:false,
        hide: false,
        isShowPop: false,
        input4: '',
        // 树

        treeProps: {
          "label": "cls_name",
          "value": 'cls_id'
        },
      }
    },
    watch: {
      chooseClsName(newVal) {
        if (this.chooseClsId.length == 2 && this.from != 'cls') { //&& this.from != 'kh'
          this.input4 = ''
          return
        }
        this.input4 = newVal
      },
      // isShowPop(newVal) {
      //   if (newVal == false) {
      //     setTimeout(() => {
      //       this.hide = true
      //     }, 310)
      //     //要下拉框点击显示时有动画效果 需要提前将div显示出来
      //     setTimeout(() => {
      //       this.hide = false
      //     }, 400)
      //   }
      // }
    },
    mounted() {
      if (this.chooseClsId.length == 2 && this.from != 'cls') { //&& this.from != 'kh'
        this.input4 = ''
        return
      }
      this.input4 = this.chooseClsName
      // this.$nextTick(function() {

      // })
    },
    methods: {
      fFocus() {
        this.isShowPop = true
        this.$nextTick(function() {
          this.$refs.tree1.setCurrentKey(this.chooseClsId);
        })
      },
      fBlur(item) {
        if (item.cls_id.length == 2 && this.from != 'cls') { //&& this.from != 'kh'
          return
        }
        this.isShowPop = false
        if(this.from == 'pro-cls-zy' ){
          this.disabled = false

        }
        this.$emit('fChooseCls', item)
      },
      //获取父级名称
      // fGetFarName(data, func) {
      //   if (data.cls_id.length > 2) {
      //     this.treeData
      //   }
      // }
      // fGetOpends(data = []) {

      //   for (let item of this.treeData) {
      //     if (item.cls_id == data.p_cls_id && item.cls_id > 2) {
      //       this.input4 = item.cls_name + '/' + this.input4

      //     }
      //     if (item.children && item.children.length) {
      //       this.fGetOpends(item.children)
      //     }
      //     if (item.data && item.data.length) {
      //       this.fGetOpends(item.data)
      //     }
      //   }
      // },
    }
  }
</script>

<style lang="less" scoped="scoped">
  .xSelectTree {
    position: relative;

    /deep/.el-input__inner {
      cursor: pointer
    }

    .mask {
      position: fixed;
      z-index: 1000;
      opacity: 0;
      top: 0;
      left: 0;
      height: 100vh;
      width: 100vw;
      background-color: #FFFFFF;
    }

    // .hide {
    //   // display: none;
    //   padding:0;
    // }
    // .show{
    //   // display: block;
    //   padding:0!important;
    // }
    .rotate {
      transform: rotate(180deg);
    }

    .h-0 {
      height: 0px;
      overflow: hidden;
      transition: all 0.3s ease;
      // border: 1px solid #E4E7ED;
      // padding: 10px 20px;
      // transition: padding 1s ease;
      opacity: 0;
    }

    .h-380 {
      max-height: 380px;
      transition: all 0.5s ease;
      // border: 1px solid #E4E7ED;
      // padding: 10px 20px;
      opacity: 1;
    }

    .pop {
      width: 100%;
      position: absolute;
      z-index: 1001;
      overflow: auto;
      border-radius: 4px;
      background-color: #FFF;
      -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      margin: 5px 0
    }


  }
</style>



// WEBPACK FOOTER //
// src/components/x-select-tree.vue